export const TYPES = {
  SET_LANGUAGE: 'SET_LANGUAGE'
}

export const setLanguage = (data) => ({
  type: TYPES.SET_LANGUAGE,
  payload: data
})


// WEBPACK FOOTER //
// ./src/actions/user.js